import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { formatCurrency } from '../../../../helpers/numbers'
import { getBudgetType } from '../../../Multiplatform/LineItemForms/typeHelpers'

import { selectedFacebookAdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { CAMPAIGN_BUDGET } from '../../../Multiplatform/CampaignForms/fields'
import { BUDGET_DAILY, BUDGET_LIFETIME } from '../../../Multiplatform/fields'

const LineItemBudgetPreview = ({ lineItem }) => {
  const { t } = useTranslation()

  const { currency_symbol } = useSelector(selectedFacebookAdAccountSelector)

  const { budget_lifetime: budgetLifetime, budget_daily: budgetDaily } = lineItem
  const budgetType = getBudgetType(budgetLifetime, budgetDaily)

  const formattedBudgetLifetime = formatCurrency(budgetLifetime, { min: 2, max: 2 }, { symbol: currency_symbol })

  const formattedBudgetDaily = formatCurrency(budgetDaily, { min: 2, max: 2 }, { symbol: currency_symbol })

  if (budgetType === BUDGET_LIFETIME) {
    return (
      <span>
        {formattedBudgetLifetime} ({t('Lifetime')})
      </span>
    )
  }

  if (budgetType === BUDGET_DAILY) {
    return (
      <span>
        {formattedBudgetDaily} ({t('Daily')})
      </span>
    )
  }

  if (budgetType === CAMPAIGN_BUDGET) {
    return <span>{t('Campaign level budget is set')}</span>
  }

  return null
}

LineItemBudgetPreview.propTypes = {
  lineItem: PropTypes.object.isRequired
}

export default LineItemBudgetPreview
